{
  "info": "Informations",
  "negative": "Erreur",
  "notice": "Avertissement",
  "positive": "Succès"
}
